import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import { FaStar, FaQuoteLeft, FaPhone, FaWhatsapp, FaCheckCircle } from 'react-icons/fa';
import SEO from '../components/SEO';
import { testimonialsData } from '../data/testimonialsData';
import './Testimonials.css';

const serviceFilters = ['All', 'Building Demolition', 'Earthwork', 'Building Materials', 'JCB Rental', 'Excavator Rental', 'Tipper Rental', 'Multiple Services'];

const Testimonials = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  const [filtered, setFiltered] = useState(testimonialsData);

  useEffect(() => { AOS.init({ duration: 1000, once: true }); }, []);

  useEffect(() => {
    setFiltered(activeFilter === 'All' ? testimonialsData : testimonialsData.filter(t => t.service === activeFilter));
  }, [activeFilter]);

  const avgRating = (testimonialsData.reduce((a, t) => a + t.rating, 0) / testimonialsData.length).toFixed(1);

  return (
    <>
      <SEO
        title="Client Testimonials - SRI KRISH CIVIL SUPPLIER | Customer Reviews Coimbatore"
        description="Read what our 300+ satisfied clients say about our building demolition, earthwork, equipment rental, and building materials services in Coimbatore."
        keywords="client reviews coimbatore, construction testimonials, customer feedback, civil supplier reviews, jcb rental reviews coimbatore, m sand supplier reviews"
      />

      <div className="page-header testimonials-header" style={{backgroundImage: 'linear-gradient(135deg, rgba(46,125,50,0.85) 0%, rgba(25,118,210,0.85) 100%), url(/new_image/Building materials.jpg)', backgroundSize: 'cover', backgroundPosition: 'top'}}>
        <div className="container">
          <h1 data-aos="fade-up">Client Testimonials</h1>
          <p data-aos="fade-up" data-aos-delay="100">What Our 300+ Valued Clients Say About SRI KRISH CIVIL SUPPLIER</p>
        </div>
      </div>

      {/* Rating Summary */}
      <section className="rating-summary-section">
        <div className="container">
          <div className="rating-summary-grid">
            <div className="rating-summary-main" data-aos="fade-up">
              <div className="big-rating">{avgRating}</div>
              <div className="big-stars">{[...Array(5)].map((_, i) => <FaStar key={i} />)}</div>
              <p>Average Rating from {testimonialsData.length} Reviews</p>
            </div>
            <div className="rating-summary-stats">
              {[
                { label: 'Total Reviews', value: `${testimonialsData.length}+` },
                { label: 'Happy Clients', value: '300+' },
                { label: 'Projects Done', value: '500+' },
                { label: 'Years Serving Coimbatore', value: '15+' },
              ].map((s, i) => (
                <div key={i} className="rs-stat" data-aos="fade-up" data-aos-delay={i * 100}>
                  <strong>{s.value}</strong>
                  <span>{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="testimonials-page">
        <div className="container">
          <div className="testimonials-filters" data-aos="fade-up">
            {serviceFilters.map(f => (
              <button key={f} className={`filter-btn ${activeFilter === f ? 'active' : ''}`} onClick={() => setActiveFilter(f)}>
                {f}
              </button>
            ))}
          </div>

          <p className="testimonials-count">Showing {filtered.length} review{filtered.length !== 1 ? 's' : ''}</p>

          <div className="testimonials-page-grid">
            {filtered.map((testimonial, index) => (
              <div key={testimonial.id} className="testimonial-page-card" data-aos="fade-up" data-aos-delay={index * 80}>
                <FaQuoteLeft className="testimonial-quote-icon" />
                <div className="testimonial-header">
                  <div className="testimonial-avatar">{testimonial.name.charAt(0)}</div>
                  <div className="testimonial-info">
                    <h3>{testimonial.name}</h3>
                    <p>{testimonial.role}</p>
                    <span className="testimonial-service-tag">{testimonial.service}</span>
                  </div>
                </div>
                <div className="testimonial-rating">
                  {[...Array(testimonial.rating)].map((_, i) => <FaStar key={i} />)}
                </div>
                <p className="testimonial-content">"{testimonial.text}"</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Clients Trust Us */}
      <section className="trust-section">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <h2>Why Clients Trust SRI KRISH CIVIL SUPPLIER</h2>
            <p>The reasons behind 300+ happy clients across Coimbatore</p>
          </div>
          <div className="trust-grid">
            {[
              { title: 'Quality You Can See', desc: 'Every project is executed with premium materials and expert workmanship that stands the test of time.' },
              { title: 'Transparent Pricing', desc: 'No hidden charges. Detailed quotes upfront. What we quote is exactly what you pay.' },
              { title: 'On-Time Every Time', desc: 'We respect your deadlines. Our efficient team and modern equipment ensure timely completion.' },
              { title: 'Safety Guaranteed', desc: 'Certified safety protocols on every site. Your property and surroundings are always protected.' },
              { title: 'Expert Team', desc: '50+ skilled professionals with 15+ years of combined experience in civil construction.' },
              { title: 'After-Service Support', desc: 'We don\'t disappear after the job. Our team is available for any post-service queries or support.' },
            ].map((t, i) => (
              <div key={i} className="trust-card" data-aos="zoom-in" data-aos-delay={i * 100}>
                <FaCheckCircle />
                <h3>{t.title}</h3>
                <p>{t.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="testimonials-cta">
        <div className="container">
          <div className="cta-content" data-aos="zoom-in">
            <h2>Join Our 300+ Happy Clients in Coimbatore</h2>
            <p>Experience the SRI KRISH difference — quality, reliability, and transparency on every project.</p>
            <div className="cta-buttons">
              <a href="tel:9894065756" className="btn btn-primary"><FaPhone /> Call: 9894065756</a>
              <a href="https://wa.me/919894065756" className="btn btn-whatsapp" target="_blank" rel="noopener noreferrer"><FaWhatsapp /> WhatsApp</a>
              <Link to="/contact" className="btn btn-secondary">Get Free Quote</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonials;
